import * as types from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const updateAllData = (state, { payload }) => payload?.content;

export default createReducer(initialState, {
  [types.FETCH_EXTRA_DETAILS_STATS_SUCCESS]: updateAllData,
});
